<template>
  <div>
    <CRow class="mb-3">
      <CCol sm="4">
        <label>{{ $pgettext('tag_definitions.form', 'Min Value') }}</label>
        <CInput
            type="number"
            v-model.number="config.min"
            :placeholder="$pgettext('tag_definitions.placeholder', 'Minimum')"
        />
      </CCol>
      <CCol sm="4">
        <label>{{ $pgettext('tag_definitions.form', 'Max Value') }}</label>
        <CInput
            type="number"
            v-model.number="config.max"
            :placeholder="$pgettext('tag_definitions.placeholder', 'Maximum')"
        />
      </CCol>
      <CCol sm="4">
        <label>{{ $pgettext('tag_definitions.form', 'Step') }}</label>
        <CInput
            type="number"
            v-model.number="config.step"
            :placeholder="$pgettext('tag_definitions.placeholder', '1')"
            min="0.01"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
export default {
  name: "NumberInputConfig",
  data() {
    return {
      config: {
        type: 'number',
        min: null,
        max: null,
        step: 1
      }
    }
  },
  methods: {
    onReset(data) {
      this.config = {
        type: 'number',
        min: null,
        max: null,
        step: 1,
        ...data
      }
    },
    onSave() {
      return this.config
    }
  }
}
</script>
